import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Avatar, Box, Typography, Container } from "@mui/material";
import imageUpload from "../functions/uploadImage";
import { writeData } from "../functions/writeData";
import { useParams } from "react-router-dom";
import { fireDB } from "../config";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { FileUpload } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function AddCategory() {
  const params = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      title: "",
      file: "",
      category_img: "",
      position: "",
    },
  });

  useEffect(() => {
    if (params.categoryId) {
      handleCategory();
    }
  }, [params]);

  async function handleCategory() {
    const docRef = doc(fireDB, "categories", params.categoryId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      setValue("title", data.title);
      setValue("position", data.position);
      setValue("category_img", data.category_img);
    }
  }

  const createCategory = async (data) => {
    let category_img;
    if (data.file) {
      category_img = await imageUpload(data.file[0]);
    }

    if (category_img || data.category_img) {
      const formData = {
        category_img: category_img || data.category_img,
        title: data.title,
        position: data.position,
      };
      if (params.categoryId) {
        await setDoc(doc(fireDB, "categories", params.categoryId), formData);
        alert("Category updated successfully");
        navigate("/dashboard/category");
      } else {
        await writeData("categories", formData);
        alert("Category created successfully");
        navigate("/dashboard/category");
      }
    }
  };

  return (
    <Container
      sx={{
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      maxWidth="sm"
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        Add a Category
      </Typography>
      <form onSubmit={handleSubmit(createCategory)}>
        <TextField
          {...register("title")}
          label="Enter Category Name"
          style={{ marginTop: 10 }}
          fullWidth
          color="primary"
        />
        <TextField
          {...register("position")}
          label="Enter Position"
          style={{ marginTop: 10 }}
          fullWidth
          color="primary"
          type="number"
        />
        <Box
          sx={{
            my: 1,
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            color="primary"
            component="label"
            variant="contained"
            sx={{ width: "100%", mr: 1 }}
          >
            <input
              type="file"
              {...register("file")}
              accept=".jpg, .jpeg, .png"
              hidden
            />
            <FileUpload fontSize="large" />
          </Button>
          {watch("file")?.length ? (
            <Avatar
              src={URL.createObjectURL(watch("file")[0])}
              sx={{ width: "50%", height: "100px", objectFit: "contain" }}
              variant="rounded"
            />
          ) : (
            <Avatar
              src={watch("category_img")}
              sx={{ width: "50%", height: "100px", objectFit: "contain" }}
              variant="rounded"
            />
          )}
        </Box>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ marginTop: "20px" }}
        >
          Add Category
        </Button>
      </form>
    </Container>
  );
}
